import React, { useEffect, useState } from 'react';
import { PageLayout } from 'components/PageLayout';
import { DocumentForm } from 'components/DocumentForm';

import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import * as api from 'api';

export const NewDoc = () => {
  const {
    rut
  } = useSelector(({ app }: RootState) => ({
    rut: app.rut
  }));
  // ** Hooks
  const { search } = useLocation();

  // ** Consts
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get('id');

  // ** State
  const [show, setShow] = useState<boolean>(false);
  const [documentData, setDocumentData] = useState<any>()

  // ** Handlers
  async function handlerGetDocument(id: string) {
    try {
      if (!rut) {
        throw new Error('RUT vacío')
      }

      const cabezal = await api.getDocumentCabezal(rut as string, Number(id));

      console.log({cabezal})

      if (!Array.isArray(cabezal) || cabezal.length === 0) {
        throw new Error('Cabezal inválido')
      }

      const lineas = await api.getDocumentLineas(rut as string, Number(id));
      
      // console.log({cabezal, lineas})

      setDocumentData({
        cabezal: cabezal[0],
        lineas
      })

    } catch (err) {
      console.error(err);
      setShow(true)
    }

  }

  // ** Effect
  useEffect(() => {
    if (id) {
      handlerGetDocument(id)
    } else {
      setShow(true)
    }
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (documentData) {
      setShow(true)
    }
  }, [documentData])

  return (
    <PageLayout title="Nuevo Documento" padding={false} whiteBg={false}>
      {show && <DocumentForm data={documentData} />}
    </PageLayout>
  );
};
